import { ReportSectionComponentType } from '../types';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useUpdateReport } from '../../common/components/mutations';
import ClientList from '../../clients/clientList';
import StepFooter from '../../common/components/stepFooter';

/**
 * Select clients (roleplayers) for the report
 */
const SelectClientStep: ReportSectionComponentType = ({
  report,
  onClickNext,
  isLoading: isSomethingLoading,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [selectedClientIds, setSelectedClientIds] = useState<number[]>(
    report.roleplayers.map(({ roleplayerID }) => roleplayerID),
  );
  const { mutate, isPending } = useUpdateReport();
  const handleClickNext = (): void => {
    if (selectedClientIds.length === 0) {
      enqueueSnackbar({ message: 'Please select a client', variant: 'error' });
      return;
    }
    mutate(
      {
        ...report,
        roleplayers: selectedClientIds.map((id) => ({
          roleplayerID: Number(id),
          reportID: report.id,
        })),
      },
      {
        onSuccess: onClickNext,
      },
    );
  };

  return (
    <>
      <ClientList
        validFirst
        selectedIds={selectedClientIds}
        onClickSelect={({ id }): void => setSelectedClientIds([id])}
      />
      <StepFooter isLoading={isPending || isSomethingLoading} onClickNext={handleClickNext} />
    </>
  );
};

export default SelectClientStep;
